

// export default `
// uniform vec4 color;
// uniform float speed;
// uniform float gradient;
// uniform float count;
// czm_material czm_getMaterial(czm_materialInput materialInput){
//     czm_material material = czm_getDefaultMaterial(materialInput);
//     vec2 st = materialInput.st;
//     float t =fract(czm_frameNumber * speed / 1000.0);
//     float v = 1.0-(1.0-smoothstep(gradient,0.0,fract(st.x*count-t)))*0.95;
//     material.diffuse = color.rgb/10.0 + vec3(v)*9.0;
//     material.alpha = color.a;
//     return material;
// }
// `



export default `
uniform vec4 backgroundColor;
uniform vec4 color;
uniform float speed;
uniform float gradient;
uniform float count;

czm_material czm_getMaterial(czm_materialInput materialInput){
    czm_material material = czm_getDefaultMaterial(materialInput);
    vec2 st = materialInput.st;
    float t = fract(czm_frameNumber * speed / 1000.0);
    float v = 1.0 - (1.0 - smoothstep(gradient, 0.0, fract(st.x * count - t))) * 0.95;
    
    material.diffuse = backgroundColor.rgb + vec3(v) * color.rgb;
    material.alpha = backgroundColor.a;
    
    return material;
}
`